module.exports = __webpack_public_path__ + "./assets/zillow_logo.png";